// import { preloadImages } from './front/utils';
// import { Navigation } from './front/navigation';
// import { Slideshow } from './front/slideshow';

// preloadImages('.slide__image').then(() => {
//   const element = document.querySelector('.slideshow');
//   const slideshow = new Slideshow(element);
//   setInterval(function() {
//     if (!element.classList.contains('pause')) {
//       slideshow.next();
//     }
//   }, 8000);
// });

window.onscroll = function() {
  let scrollHeight = window.pageYOffset;

  const video = document.querySelector('.js-video');
  if (video) {
    video.style.top = '-' + (scrollHeight * .5) + 'px';
  }

  const amp = document.querySelector('.js-amp');
  if (amp) {
    // amp.style.opacity = (scrollHeight / .005);
    amp.style.opacity = Math.max(0, Math.min(1, -scrollHeight / 300 + 2));
  }
};
